/**
 * Yodlee/aggregator action types as exposed by the backend `ErrorDetails.ActionType`.
 * Mirrors WealthInstitutionErrorAction (noodle-soup). Values are the lowercased
 * tokens used for case-insensitive comparison (legacy parity).
 */
export enum WealthInstitutionErrorAction {
  None = 'none',
  AuthenticationRequired = 'authenticationrequired',
  ConsumerSiteRequired = 'consumersiterequired',
  ShowMessage = 'showmessage',
  SiteMessage = 'sitemessage',
  AgentActionRequired = 'agentactionrequired',
  MfaAuthenticationRequired = 'mfaauthenticationrequired',
  DiscoverAdd = 'discoveradd',
  CloseAccount = 'closeaccount',
}

/**
 * Action types where the user CANNOT self-resolve via FastLink re-auth.
 * Ported from legacy `ableToFixIt` (ErrorMessage.jsx).
 */
const NON_ACTIONABLE = new Set<string>([
  'none',
  'consumersiterequired',
  'showmessage',
  'sitemessage',
  'agentactionrequired',
  'sitesuccessmessage',
  'aggregatortemporarlydisabled',
  'closeaccount',
  'intuitmigration',
]);

export function isActionable(actionType: string | undefined | null): boolean {
  if (!actionType) {
    return false;
  }
  return !NON_ACTIONABLE.has(actionType.toLowerCase());
}

/** Institution-site lock/terms/enrollment — open InstitutionUrl, not FastLink. */
export function isConsumerSiteRequired(
  actionType: string | undefined | null,
): boolean {
  return (
    actionType?.toLowerCase() ===
    WealthInstitutionErrorAction.ConsumerSiteRequired
  );
}

export function resolveFlow(
  actionType: string | undefined | null,
  externalId = 0,
): 'add' | 'edit' | 'refresh' {
  if (
    actionType?.toLowerCase() ===
    WealthInstitutionErrorAction.MfaAuthenticationRequired
  ) {
    return 'refresh';
  }

  return externalId ? 'edit' : 'add';
}
